import gql from 'graphql-tag';

import starredObjectsFragment from '../fragments/starredObjectsFragment';

export const queryStarredObjects = gql`
  query starredObjects {
    starredObjects {
      ...starredObjectsFragment
    }
  }
  ${starredObjectsFragment}
`;
export default queryStarredObjects;
